import React from 'react'
import { Link } from 'gatsby';
export default function NewSubscribedMessage() {
  const closeWhenGo = event => {
    event.preventDefault();
    $('#email').modal('hide');
  };
    return (
        <div className="container p-4">
                    <div className="section-title section-title-blue text-align-center">
                      <h6>Successfully subscribed!</h6>
                      <p>
                        Before you can receive free updates, Business strategies, and Growth tips{' '}
                      </p>
                    </div>
                    <div className="justify-content">
                      <p>Checkout These 2 to Get Started!!</p>
                      <Link
                        to="/business-ideas"
                        onClick={() => closeWhenGo()}
                        mdb-toggle="tooltip"
                        title="This E-book contains 103 Online Business Ideas categorised into 7 major categories with all resources you need to get started"
                      >
                        E-Book #1: 103 Business Ideas
                      </Link>
                      <br />
                      <br />
                      <Link
                        onClick={() => closeWhenGo()}
                        to="/online-business-quickstart-checklist"
                        mdb-toggle="tooltip"
                        title="It will help you in excecuting your Business Idea to make it a great success"
                      >
                        Checklist #1: Online Business Quick Start Checklist
                      </Link>
                      <br />
                      <br />
                      Talk Soon,
                      <br />
                      Apoorva
                    </div>
                  </div>
    )
}
